// Tela Mobile (PWA) · scan QR pela câmera + 4 ações de chão
// Pensada pra celular do conferente. Botões grandes, fluxo de 1 ação por vez.
import { Html5Qrcode } from 'html5-qrcode';
import { db, repo, getCurrentUser } from '../client.js';
import { escapeHTML, DT, QTY, NUM } from '../shared.js';

let scanner = null;

export async function viewMobile($c) {
  const user = await getCurrentUser();
  $c.innerHTML = `
    <div class="mobile-shell">
      <header class="mob-head">
        <div class="mob-brand">
          <span class="mob-zzyon">ZZYON</span>
          <span class="mob-sub">TORRE BINÁRIO</span>
        </div>
        <div class="mob-user">${escapeHTML((user?.email || '').slice(0, 1).toUpperCase())}</div>
      </header>

      <div class="mob-scan-wrap">
        <div id="mob-scan" class="mob-scan"></div>
        <div class="mob-scan-overlay">
          <div class="mob-scan-frame"></div>
        </div>
      </div>

      <div class="mob-status" id="mob-status">
        <div class="mob-status-icon">◎</div>
        <div class="mob-status-text">Aponte para um QR — volume, endereço ou SKU</div>
      </div>

      <div class="mob-actions">
        <button class="mob-btn" data-act="receber">
          <span class="mob-btn-icon">▽</span>
          <span class="mob-btn-label">Receber volume</span>
          <span class="mob-btn-sub">cria volume + QR</span>
        </button>
        <button class="mob-btn" data-act="endereçar">
          <span class="mob-btn-icon">◰</span>
          <span class="mob-btn-label">Endereçar</span>
          <span class="mob-btn-sub">scan vol + scan loc</span>
        </button>
        <button class="mob-btn" data-act="picking">
          <span class="mob-btn-icon">⇉</span>
          <span class="mob-btn-label">Picking</span>
          <span class="mob-btn-sub">lista do dia</span>
        </button>
        <button class="mob-btn" data-act="contar">
          <span class="mob-btn-icon">⊟</span>
          <span class="mob-btn-label">Contar</span>
          <span class="mob-btn-sub">inventário cego</span>
        </button>
      </div>

      <div class="mob-modal" id="mob-modal" style="display:none;">
        <div class="mob-modal-inner">
          <div class="mob-modal-head">
            <h3 id="mob-modal-title">…</h3>
            <button class="mob-modal-close" id="mob-modal-close">✕</button>
          </div>
          <div id="mob-modal-body"></div>
        </div>
      </div>

      <footer class="mob-foot">
        <a href="#/dashboard">← versão desktop</a>
        <span>${escapeHTML(user?.email || 'não autenticado')}</span>
      </footer>
    </div>
  `;

  // Camera scanner
  await startScanner();

  document.querySelectorAll('.mob-btn').forEach(b => b.addEventListener('click', () => abrirAcao(b.dataset.act)));
  document.getElementById('mob-modal-close').addEventListener('click', closeModal);
}

async function startScanner() {
  try {
    const el = document.getElementById('mob-scan');
    if (!el) return;
    if (scanner) await stopScanner();
    scanner = new Html5Qrcode('mob-scan');
    await scanner.start(
      { facingMode: 'environment' },
      { fps: 8, qrbox: { width: 240, height: 240 }, aspectRatio: 1.0 },
      onScan,
      () => { /* ignore scan errors */ }
    );
  } catch (e) {
    const s = document.getElementById('mob-status');
    if (s) s.innerHTML = `<div class="mob-status-icon">⚠</div><div class="mob-status-text">Câmera indisponível: ${escapeHTML(e.message || String(e))}</div>`;
  }
}

async function stopScanner() {
  if (!scanner) return;
  try { await scanner.stop(); await scanner.clear(); } catch (_e) {}
  scanner = null;
}

async function onScan(decodedText) {
  // Detect tipo do payload
  const m = decodedText.match(/^BINW:(VOL|LOC|SKU):(.+)$/);
  if (!m) {
    setStatus('warn', '⚠', `Código não reconhecido: ${decodedText.slice(0, 36)}`);
    return;
  }
  const [, tipo, code] = m;
  await stopScanner();
  setStatus('ok', '✓', `${tipo}: ${code}`);

  if (tipo === 'VOL') await abrirVolume(code);
  else if (tipo === 'LOC') await abrirEndereco(code);
  else if (tipo === 'SKU') await abrirSku(code);
}

function setStatus(kind, icon, msg) {
  const s = document.getElementById('mob-status');
  if (!s) return;
  s.className = `mob-status ${kind}`;
  s.innerHTML = `<div class="mob-status-icon">${icon}</div><div class="mob-status-text">${escapeHTML(msg)}</div>`;
}

async function abrirVolume(code) {
  openModal(`Volume ${code}`, '<div class="empty"><span class="spinner"></span>Carregando…</div>');
  const vol = await repo.getVolume(code);
  if (!vol) {
    setModalBody(`
      <div class="msg warn"><strong>⚠ Volume não cadastrado</strong></div>
      <button class="mob-btn-full" id="m-criar">Criar agora com este código?</button>
    `);
    document.getElementById('m-criar').addEventListener('click', async () => {
      try {
        // criar manual
        await db.from('volume').insert({ volume_codigo: code, qtd: 1, status: 'recebido', qr_payload: `BINW:VOL:${code}` });
        await abrirVolume(code);
      } catch (e) { alert('Erro: ' + e.message); }
    });
    return;
  }
  setModalBody(`
    <table class="mob-info">
      <tr><td>SKU</td><td>${escapeHTML(vol.sku_codigo || '—')}</td></tr>
      <tr><td>Descrição</td><td>${escapeHTML((vol.sku_descricao || '').slice(0, 40))}</td></tr>
      <tr><td>Qtd</td><td>${QTY(vol.qtd)} ${escapeHTML(vol.unid || '')}</td></tr>
      <tr><td>Endereço atual</td><td><strong>${escapeHTML(vol.endereco || '— sem endereço —')}</strong></td></tr>
      <tr><td>Status</td><td><span class="pill pill-blue">${escapeHTML(vol.status)}</span></td></tr>
      <tr><td>Serial</td><td>${escapeHTML(vol.serial || '—')}</td></tr>
    </table>
    <div class="mob-actions-stack">
      <button class="mob-btn-full" id="m-realoc">→ Mover para outro endereço (scan)</button>
      <button class="mob-btn-full subtle" id="m-back">← Continuar scaneando</button>
    </div>
  `);
  document.getElementById('m-realoc').addEventListener('click', () => abrirRealocFlow(code));
  document.getElementById('m-back').addEventListener('click', () => { closeModal(); startScanner(); });
}

async function abrirEndereco(code) {
  openModal(`Endereço ${code}`, '<div class="empty"><span class="spinner"></span>Carregando…</div>');
  const { data: end } = await db.from('endereco').select('*').eq('endereco_codigo', code).maybeSingle();
  if (!end) {
    setModalBody(`<div class="msg warn">⚠ Endereço não cadastrado em <span class="mono-inline">${escapeHTML(code)}</span></div>`);
    return;
  }
  const { data: vols } = await db.from('vw_volume_ativo').select('volume_codigo,sku_codigo,sku_descricao,qtd').eq('endereco', code).limit(20);
  setModalBody(`
    <table class="mob-info">
      <tr><td>Rua / Mód / Nível</td><td><strong>${end.rua}-${String(end.modulo).padStart(2,'0')}-${end.nivel}-${String(end.posicao).padStart(2,'0')}</strong></td></tr>
      <tr><td>Tipo</td><td>${escapeHTML(end.tipo)}</td></tr>
      <tr><td>Golden zone</td><td>${end.golden_zone ? '★ sim' : '—'}</td></tr>
      <tr><td>Capacidade</td><td>${end.capacidade_qtd || '—'}</td></tr>
      <tr><td>Volumes aqui</td><td><strong>${(vols || []).length}</strong></td></tr>
    </table>
    ${(vols || []).length > 0 ? `
      <div class="mob-vol-list">
        ${vols.map(v => `<div class="mob-vol-row"><span class="mono">${escapeHTML(v.volume_codigo)}</span><span>${escapeHTML((v.sku_codigo || '—').slice(0,16))}</span><span class="num">${QTY(v.qtd)}</span></div>`).join('')}
      </div>
    ` : '<div class="empty">Endereço vazio.</div>'}
    <button class="mob-btn-full subtle" id="m-back">← Continuar scaneando</button>
  `);
  document.getElementById('m-back').addEventListener('click', () => { closeModal(); startScanner(); });
}

async function abrirSku(code) {
  openModal(`SKU ${code}`, '<div class="empty"><span class="spinner"></span>Carregando…</div>');
  const { data: sku } = await db.from('vw_posicao_estoque').select('*').eq('sku_codigo', code).maybeSingle();
  if (!sku) { setModalBody('<div class="msg warn">⚠ SKU não cadastrado.</div>'); return; }
  setModalBody(`
    <table class="mob-info">
      <tr><td>Descrição</td><td>${escapeHTML((sku.descricao || '').slice(0, 50))}</td></tr>
      <tr><td>Categoria</td><td>${escapeHTML(sku.categoria || '—')}</td></tr>
      <tr><td>Classe</td><td><span class="pill pill-solid-blue">${sku.classe_abc || '·'}${sku.classe_xyz || ''}</span></td></tr>
      <tr><td>Endereço sugerido</td><td><strong>${escapeHTML(sku.endereco_atual || '—')}</strong></td></tr>
      <tr><td>Saldo atual</td><td><strong>${QTY(sku.saldo_qtd)}</strong></td></tr>
      <tr><td>Valor referência</td><td>R$ ${Number(sku.valor_referencia || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td></tr>
    </table>
    <button class="mob-btn-full subtle" id="m-back">← Continuar scaneando</button>
  `);
  document.getElementById('m-back').addEventListener('click', () => { closeModal(); startScanner(); });
}

async function abrirRealocFlow(volCode) {
  openModal(`Mover ${volCode}`, `
    <p class="text-sm text-mute mb-md">Escaneie o QR do endereço destino.</p>
    <div id="mob-scan-dest" class="mob-scan-mini"></div>
    <button class="mob-btn-full subtle" id="m-cancel-realoc">cancelar</button>
  `);
  const target = new Html5Qrcode('mob-scan-dest');
  await target.start(
    { facingMode: 'environment' },
    { fps: 8, qrbox: { width: 220, height: 220 } },
    async (decoded) => {
      const m = decoded.match(/^BINW:LOC:(.+)$/);
      if (!m) { setStatus('warn', '⚠', 'Não é endereço'); return; }
      await target.stop(); await target.clear();
      try {
        const r = await repo.realocarVolume({ volume_codigo: volCode, endereco_destino: m[1], motivo: 'realocacao', responsavel: 'mobile' });
        setModalBody(`<div class="msg ok"><strong>✓ Movido</strong><br>${escapeHTML(volCode)}: ${r.from || '∅'} → <strong>${r.to}</strong></div>
          <button class="mob-btn-full" id="m-back2">← Continuar</button>`);
        document.getElementById('m-back2').addEventListener('click', () => { closeModal(); startScanner(); });
      } catch (e) {
        setModalBody(`<div class="msg err">Erro: ${escapeHTML(e.message)}</div>`);
      }
    },
    () => {}
  );
  document.getElementById('m-cancel-realoc').addEventListener('click', async () => {
    try { await target.stop(); await target.clear(); } catch (_e) {}
    closeModal(); startScanner();
  });
}

async function abrirAcao(act) {
  await stopScanner();
  if (act === 'receber') {
    openModal('Receber volume', `
      <p class="text-sm text-mute mb-md">Cria volume e gera código <span class="mono-inline">VOL-YYYYMMDD-XXXXXX</span>. Imprima a etiqueta depois em <em>Etiquetas</em>.</p>
      <form id="m-recv" class="form-stack">
        <label>SKU<input id="r-sku" placeholder="cProd"></label>
        <label>Qtd<input id="r-qtd" type="number" step="0.01" value="1" required></label>
        <label>Serial (opcional)<input id="r-ser"></label>
        <button type="submit" class="mob-btn-full">+ Criar volume</button>
        <button type="button" class="mob-btn-full subtle" id="r-cancel">cancelar</button>
      </form>
      <div id="r-result"></div>
    `);
    document.getElementById('r-cancel').addEventListener('click', () => { closeModal(); startScanner(); });
    document.getElementById('m-recv').addEventListener('submit', async (e) => {
      e.preventDefault();
      try {
        const vol = await repo.criarVolume({
          sku_codigo: document.getElementById('r-sku').value || null,
          qtd: parseFloat(document.getElementById('r-qtd').value || '1'),
          serial: document.getElementById('r-ser').value || null,
          status: 'recebido',
        });
        document.getElementById('r-result').innerHTML = `<div class="msg ok"><strong>✓ Criado</strong><br><span class="mono-inline">${vol.volume_codigo}</span></div>
          <button class="mob-btn-full" id="r-ok">OK, continuar scan</button>`;
        document.getElementById('r-ok').addEventListener('click', () => { closeModal(); startScanner(); });
      } catch (err) { alert('Erro: ' + err.message); }
    });
  } else if (act === 'endereçar') {
    openModal('Endereçar volume', `<p class="text-sm text-mute mb-md">Escaneie primeiro o <strong>volume</strong>, depois o <strong>endereço</strong>.</p>
      <div id="mob-scan-src" class="mob-scan-mini"></div>
      <div id="m-step1">Aguardando QR do volume…</div>
      <button class="mob-btn-full subtle" id="e-cancel">cancelar</button>`);
    document.getElementById('e-cancel').addEventListener('click', async () => { try{await scanner?.stop();}catch{} closeModal(); startScanner(); });
    const src = new Html5Qrcode('mob-scan-src');
    await src.start({ facingMode: 'environment' }, { fps: 8, qrbox: { width: 220, height: 220 } }, async (d) => {
      const m = d.match(/^BINW:VOL:(.+)$/);
      if (!m) return;
      await src.stop(); await src.clear();
      await abrirRealocFlow(m[1]);
    }, () => {});
  } else if (act === 'picking') {
    openModal('Pickings pendentes', '<div class="empty"><span class="spinner"></span>Carregando…</div>');
    const pend = await repo.pickingPendentes();
    if (pend.length === 0) {
      setModalBody('<div class="empty">Sem pickings pendentes.</div><button class="mob-btn-full subtle" id="p-back">←</button>');
    } else {
      setModalBody(`<div class="mob-list">${pend.map(p => `
        <div class="mob-list-row" data-pid="${p.id}">
          <div class="mob-list-title">${escapeHTML(p.numero)}</div>
          <div class="mob-list-sub">${escapeHTML(p.destinatario || '—')} · ${escapeHTML(p.cidade_destino || '')}</div>
          <div class="mob-list-meta">${p.itens_separados || 0}/${p.total_itens || 0} itens</div>
        </div>
      `).join('')}</div><button class="mob-btn-full subtle" id="p-back">← Continuar scan</button>`);
    }
    document.getElementById('p-back').addEventListener('click', () => { closeModal(); startScanner(); });
  } else if (act === 'contar') {
    openModal('Contagem cega', '<div class="empty"><span class="spinner"></span>Carregando…</div>');
    const { data: itens } = await db.from('vw_inventario_dia').select('*').eq('situacao', 'hoje').or('situacao.eq.atrasado').limit(20);
    if (!itens || itens.length === 0) {
      setModalBody('<div class="empty">Sem contagens programadas hoje.</div><button class="mob-btn-full subtle" id="c-back">←</button>');
    } else {
      setModalBody(`<div class="mob-list">${itens.map(i => `
        <div class="mob-list-row" data-cid="${i.id}" data-sku="${escapeHTML(i.sku_codigo)}">
          <div class="mob-list-title">${escapeHTML(i.sku_codigo)}</div>
          <div class="mob-list-sub">${escapeHTML((i.sku_descricao || '').slice(0, 36))} · ${escapeHTML(i.endereco || '—')}</div>
          <div class="mob-list-meta"><span class="pill pill-blue">${escapeHTML(i.classe_abc || '·')}${escapeHTML(i.classe_xyz || '')}</span> ${escapeHTML(i.ciclo)}</div>
        </div>
      `).join('')}</div><button class="mob-btn-full subtle" id="c-back">←</button>`);
      document.querySelectorAll('.mob-list-row[data-cid]').forEach(r => r.addEventListener('click', () => abrirContagem(parseInt(r.dataset.cid, 10), r.dataset.sku)));
    }
    document.getElementById('c-back').addEventListener('click', () => { closeModal(); startScanner(); });
  }
}

async function abrirContagem(id, sku) {
  setModalBody(`
    <p class="text-sm text-mute mb-md">Conte fisicamente <strong>${escapeHTML(sku)}</strong>. <span style="color: var(--warning);">Não veja o saldo do sistema.</span></p>
    <form id="m-cont" class="form-stack">
      <label>Quantidade contada<input id="cc-qtd" type="number" step="0.01" required autofocus></label>
      <label>Seu nome<input id="cc-resp" required></label>
      <button type="submit" class="mob-btn-full">✓ Registrar</button>
    </form>
    <div id="cc-result"></div>
  `);
  document.getElementById('m-cont').addEventListener('submit', async (e) => {
    e.preventDefault();
    try {
      const { data, error } = await db.rpc('registrar_contagem', {
        p_id: id,
        p_saldo_contado: parseFloat(document.getElementById('cc-qtd').value),
        p_responsavel: document.getElementById('cc-resp').value,
      });
      if (error) throw error;
      const r = document.getElementById('cc-result');
      if (data.divergente) {
        r.innerHTML = `<div class="msg warn"><strong>⚠ Divergência</strong> Sistema: ${QTY(data.sistema)} · Contado: ${QTY(data.contado)} · Dif: ${QTY(data.divergencia)}<br>Exceção aberta automaticamente.</div>`;
      } else {
        r.innerHTML = `<div class="msg ok"><strong>✓ OK</strong> Contagem confere com sistema.</div>`;
      }
      setTimeout(() => { closeModal(); startScanner(); }, 2500);
    } catch (err) { alert('Erro: ' + err.message); }
  });
}

function openModal(title, html) {
  document.getElementById('mob-modal-title').textContent = title;
  document.getElementById('mob-modal-body').innerHTML = html;
  document.getElementById('mob-modal').style.display = 'flex';
}
function setModalBody(html) {
  document.getElementById('mob-modal-body').innerHTML = html;
}
async function closeModal() {
  document.getElementById('mob-modal').style.display = 'none';
}

// cleanup quando sai da rota
window.addEventListener('hashchange', () => {
  if (!location.hash.startsWith('#/mobile')) stopScanner();
});
